export default __webpack_public_path__ + "static/media/bellybutton.11f73c5a.png";